export function getReportTextHtml(exportFileEx: any): string {

    //funcion ingresa export FIle --regresar string>
    // var aFileParts = '<html ><table style="width:100%;border: 0px solid black;" >';
    var aFileParts = '<html><head> <style> *{font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";}</style></head><table style="width:100%;border: 0px solid black;" >';

    for (let index = 0; index < exportFileEx[0].rows.length; index++) {
        const row = exportFileEx[0].rows[index];

        var height_celda:any = row.height;

        // console.log(row.height+" ___ "+row.hasOwnProperty('cells'));
        // console.log(element.cells);
        // console.log(element.hasOwnProperty('cells'));
        aFileParts += '<tr '+
                    'style="height:'+ height_celda *(3/4) +'pt;"'+
                    '>';

        if (row.hasOwnProperty('cells')) {

        // console.log(row['cells']);
        // console.log(row.cells);
        var celdas: any = row.cells;

        for (let j = 0; j < celdas.length; j++) {

            var font_weight = 'normal';
            if ( celdas[j].bold ) {
            font_weight = 'bold';
            }

            aFileParts += '<td '+
                        'colspan="'+celdas[j].colSpan+'" '+
                        'rowspan="'+celdas[j].rowSpan+'" '+
                        'style="font-size:'+ celdas[j].fontSize+
                            '; color:'+ celdas[j].color+
                            '; font-weight:'+ font_weight+
                            '; background-color:'+ celdas[j].background+
                            '; vertical-align: middle;text-align: center;"'+
                            '>';

            if (celdas[j].hasOwnProperty('formula')) {
            var aux = celdas[j].formula.split("maps?q=")[1];
            aux = aux.split("&amp;t=m")[0]; //-16.480746,-71.618448
            //   "HYPERLINK("http://maps.google.com/maps?q=-16.480746,-71.618448&amp;t=m","-16.480746,-71.618448")"
            aFileParts += '<a style="text-decoration: none;" href="http://maps.google.com/maps?q='+aux+'&amp;t=m" target="_blank">'+aux+'</a>'
            } else {
                // const element = array[j];
                //aFileParts += celdas[j].value;
                if(celdas[j].value === undefined){
                    //console.log("--------es indefinido");
                    aFileParts += "";
                } else {
                    aFileParts += celdas[j].value;
                }
            }

            aFileParts += '</td>';

        }
        }
        aFileParts += '</tr>';
    }

    aFileParts += '</table></a></html>';


    return aFileParts;

}
